export const getOrderDiscountAmount = order => {
  if (!order) {
    return null;
  }

  return order.subtotal_before_discounts - order.subtotal;
};
